'use client'
import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import {Container, Row, Col} from "react-bootstrap";
import {Img} from "@/components/Img";
import Title from "@/components/Title";
import {black, hover, text, white} from "@/styles/globalStyleVars";
import Button from "@/components/Button";
import parser from "html-react-parser";
import PopupForms from "@/components/PopupForms";
import PopupFormsSubscription from "@/components/PopupFormsSubscription";




const AtGlance = ({data}) => {


    const [offset, setOffset] = useState(90)
    useEffect(() => {
        if (window.innerWidth > 767) {
            setOffset(document.querySelector('.container')?.offsetLeft)
        }
        window.addEventListener('resize', () => {
            if (window.innerWidth > 767) {
                setOffset(document.querySelector('.container')?.offsetLeft)
            }
        })


    }, [])


    const [show, setShow] = useState(false);
    const [popupId, setPopupId] = useState()

    const handleClose = () => {
        setShow(false)
        document.querySelector('body').classList.remove('scription')

    };
    const handleShow = (data) => {
        setShow(true);
        setPopupId(data); // Set popupId to the data object
        document.querySelector('body').classList.add('scription')
    };

    return (
        <StyledOverviewWithImage  id={'glance'} className='atglance pt-120 pb-120' offset={offset} style={{background:'#000'}}>
            <Container>
                <Row className={'atglance-row'}>
                    <Col md={12} className='atglance__content'>
                        <div className='atglance__content__title '>
                            <Title text={data?.title} color={`${white}`}/>
                            {
                                data?.description &&
                                <p className={'split-up description'}>
                                    {parser(data?.description)}
                                </p>
                            }

                            {
                                data?.list && data?.list?.length > 0 &&
                                <table>


                                    {
                                        data?.list && data?.list?.length > 0 &&
                                        data?.list?.map((e, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td><img height={20} width={20} src={e?.icon} alt={e?.title}/></td>
                                                    <td>{e?.title}</td>
                                                    <td>{e?.short_desc}</td>
                                                </tr>
                                            )
                                        })
                                    }
                                </table>
                            }

                            {/*{*/}
                            {/*    data?.pdf &&*/}
                            {/*    <div className="disclaimer">*/}
                            {/*        <Button text={'Download Brochure'} border={`1px`}*/}
                            {/*                borderColor={`${white}`} src={data?.pdf} target={'_blank'}*/}
                            {/*                hoverBackground={`${hover}`}*/}
                            {/*                color={`${white}`}*/}
                            {/*                padding={'10px 20px'}/>*/}
                            {/*    </div>*/}
                            {/*}*/}
                            <div className="disclaimer" onClick={(e) => handleShow(e)}>
                                <Button text={'Download Brochure'} border={`1px`}
                                        borderColor={`${white}`} src={'javascript:void(0)'}
                                        hoverBackground={`${hover}`}
                                        color={`${white}`}
                                        padding={'10px 20px'}/>
                            </div>

                        </div>
                    </Col>
                </Row>
            </Container>
            <PopupFormsSubscription show={show} pdf={data?.pdf ? data?.pdf : ''} data={popupId} handleClose={handleClose}/>

        </StyledOverviewWithImage>
    );
};
const StyledOverviewWithImage = styled.section`
    position: relative;

    h2 {
        font-weight: 800;
    }

    p {
        color: white;

        &.description {
            margin-bottom: 40px;
        }
    }

    .atglance {
        &__img {
            position: relative;
            padding-top: calc(750 / 668 * 100%);
            @media (max-width: 767px) {
                position: relative;
                padding-top: calc(500 / 345 * 100%);
            }

            .lower-logo {
                position: absolute;
                bottom: 0;
                height: 120px;
                background: rgba(137, 112, 89, 0.8);
                width: 100%;

                img {
                    height: 80px;
                }
            }
        }

        &__content {
            color: ${black};
            display: flex;
            align-items: center;

            @media (max-width: 991px) {
                padding-top: 50px;
            }
            @media (max-width: 767px) {
                padding-right: 15px !important;
                padding-left: 30px;
                padding-bottom: 80px;
            }

            &__title {
                width: 100%;

                h1 {
                    font-size: 80px;
                    line-height: 80px;
                    font-weight: 400;
                    text-transform: uppercase;
                }

                table {
                    margin-top: 20px;
                    display: flex;
                    flex-wrap: wrap;
                    gap: 30px;

                    tr {
                        display: flex;
                        width: 100%;
                        padding-bottom: 20px;
                        border-bottom: 1px solid #F9F9F9;
                        flex: 0 0  calc(50% - 30px);


                        &:last-child {
                            td {
                                padding-bottom: 0;
                            }
                        }
                        
                        
                        @media(max-width: 768px){
                            flex: 0 0 calc(100% - 30px);
                        }

                    }

                    &:last-child {
                        margin-bottom: 0;

                    }

                    td {
                        font-weight: 500;
                        font-size: 14px;
                        line-height: 21px;
                        color: ${white};

                        &:first-child {
                            flex: 0 0 auto;
                            margin-right: 20px;
                        }

                        &:nth-child(2) {
                            color: rgba(255, 255, 255, 0.7);
                            font-weight: 500;
                            flex: 0 0 35%;


                        }

                        &:last-child {
                            color: rgba(255, 255, 255);
                        }

                    }
                }

                .disclaimer {
                    margin-top: 40px;
                    display: flex;
                    justify-content: flex-start;
                    align-items: flex-end;
                    height: 100%;
                    gap: 6px;

                    p {
                        font-size: 16px;
                        line-height: 24px;
                        font-weight: 500;
                        color: #B2A89F;
                        height: 22px;

                    }
                }

            }
        }
    }

    @media (max-width: 767px) {
        .atglance-row {
            flex-direction: column-reverse;
        }

        .title {
            margin-bottom: 0 !important;
        }
    }
    background: #525F6E !important;


`;
export default AtGlance;